var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.9984,
    cy: 148.666,
    rx: 59.4667,
    ry: 49.7333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.9991,
    cy: 72.8005,
    rx: 38.6667,
    ry: 45.6,
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5317,
    y: 148.8,
    width: 118.933,
    height: 17.8667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.9997,
    cy: 72.7996,
    rx: 31.4667,
    ry: 35.4667,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaIcon);
export default __webpack_public_path__ + "static/media/Ava-Icon.1020c9e6f35bf1063d7548595e91ed42.svg";
export { ForwardRef as ReactComponent };